const tagsTitle = ["naming"];
const sizeTagsOnPage = 200;
export { tagsTitle, sizeTagsOnPage };
